import React, { useState, useEffect, useRef } from "react";
import { corefetch, corepost, ImageURL } from "../../../Util/axios_core_helper";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { CommonErrorMsg, ErrorMsg, ValidateForm } from "../../../Util/common";
import { KendoDatePicker } from "../../../Kendo/kendo_datepicker";
import { toast } from "react-toastify";
import ReactPlayer from "react-player";

const Cart = () => {
  const { itemid } = useParams();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [popupImageSrc, setPopupImageSrc] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [selectedImage, setSelectedImage] = useState(null);
  const [categories, setCategories] = useState([]);
  const [showModal, setShowModal] = useState(false); // Modal visibility state
  const [isMeridianClient, setIsMeridianClient] = useState(false);
  const [isToggleOn, setIsToggleOn] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ballroomData, setBallroomData] = useState([]);
  const [showThankYouModal, setShowThankYouModal] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [popupSrc, setPopupSrc] = useState("");
  const [selectedContent, setSelectedContent] = useState(null);
  const picZoomerRef = useRef(null);
  const initialImageLoadedRef = useRef(false);
  const [calendlyLinks, setCalendlyLinks] = useState(null);
  const [showCalendlyModal, setShowCalendlyModal] = useState(false);
  const [selectedCalendlyUrl, setSelectedCalendlyUrl] = useState("");
  const [BreadcrumList, setBreadcrumList] = useState([]);

  const [isVideo, setIsVideo] = useState(false);
  const [vendor, setVendor] = useState({
    MeridianCustomerId: 0,
    ClientName: "",
    EventDate: "",
    BallroomID: 0,
    ClientPhoneNumber: "",
    ClientEmailID: "",
    Name: "",
    Email: "",
    PhoneNumber: "",
    OutsideEventDate: "",
    VenueLocation: "",
    IsMeridianClient: 0,
  });
  const [error, setError] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await corefetch(
          `Rental/GetRentalItemDetailsForCart?itemId=${itemid}`
        );
        if (response && response.length > 0) {
          const mappedItems = response.map((item) => ({
            ...item,
            image: item.imagePath ? `${ImageURL}${item.imagePath}` : null,
          }));
          setItems(mappedItems);
        } else {
          setItems([]);
        }
      } catch (error) {
        setItems([]); // Set empty if error occurs
        console.error("Error fetching items:", error);
      }
    };
const fetchBreadcrumImageData = async () => {
      try {
        const response = await corefetch(
          "Breadcrum/GetBreadcrumDetailsByCategory?CategoryCode=RCART"
        );
        if (response && response.length > 0) {
          console.log("fxftyxfyt:", response);
          setBreadcrumList(response);
        } else {
          setBreadcrumList([]);
          console.log("No Breadcrum found");
        }
      } catch (error) {
        console.error("Error fetching Breadcrum List:", error);
        setBreadcrumList([]);
      }
    };
    fetchData();
    fetchBreadcrumImageData();
  }, [itemid]);

  const backgroundImageStyle = BreadcrumList[0]
  ? {
      backgroundImage: `url(${ImageURL}${BreadcrumList[0].imagePath})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }
  : {};

  const openPopup = (src) => {
    setPopupSrc(src);
    // setPopupImageSrc(src);
    setPopupOpen(true);
  };

  const closePopup = (e) => {
    e.stopPropagation();
    setPopupSrc("");
    setPopupOpen(false);
  };
  const handleImageClick = (imageUrl) => {
    setSelectedContent(imageUrl);
    setIsVideo(false);
  };

  const handleVideoClick = (videoUrl) => {
    setSelectedContent(videoUrl);
    setIsVideo(true);
  };

  // const handleImageClick = (src) => {
  //   setSelectedImage(src);
  //   setSelectedVideo(null);
  // };
  useEffect(() => {
    const storedCart = localStorage.getItem("cart_items");
    if (storedCart) {
      const cartItems = JSON.parse(storedCart);
      const currentItem = cartItems.find(
        (item) => item.itemid === items[0]?.itemid
      );
      if (currentItem) {
        setQuantity(currentItem.quantity);
      } else {
        setQuantity(1); // Set quantity to 1 if the item is not in the cart
      }
    } else {
      setQuantity(1); // Set quantity to 1 if no cart is found in localStorage
    }
  }, [items, itemid]);

  const updateLocalStorage = (newQuantity) => {
    const storedCart = localStorage.getItem("cart_items");
    let cartItems = storedCart ? JSON.parse(storedCart) : [];

    // Check if item already exists in cart
    const existingItemIndex = cartItems.findIndex(
      (item) => item.itemid === items[0]?.itemid
    );

    if (existingItemIndex !== -1) {
      // Update the quantity if the item exists
      cartItems[existingItemIndex].quantity = newQuantity;
    } else {
      // If item doesn't exist, add it with the new quantity
      const newItem = {
        itemid: items[0]?.itemid,
        itemName: items[0]?.itemName,
        imagePath: items[0]?.imageModels?.[0]?.imagePath || "",
        category: items[0]?.category,
        quantity: newQuantity,
      };
      cartItems.push(newItem);
    }

    // Save the updated cart back to localStorage
    localStorage.setItem("cart_items", JSON.stringify(cartItems));
  };

  const coverImage = items
    .find((item) => item.imageModels?.some((img) => img.isCoverPhoto === 1))
    ?.imageModels?.find((img) => img.isCoverPhoto === 1)?.imagePath;

  useEffect(() => {
    const $ = window.jQuery;

    // Define the picZoomer plugin if not already defined
    if (typeof $.fn.picZoomer !== "function") {
      (function ($) {
        $.fn.picZoomer = function (options) {
          var opts = $.extend({}, $.fn.picZoomer.defaults, options),
            $this = this,
            $picBD = $('<div class="picZoomer-pic-wp"></div>')
              .css({
                width: "auto", // Set width to auto
                height: opts.picHeight + "px",
              })
              .appendTo($this),
            $pic = $this
              .children("img")
              .addClass("picZoomer-pic")
              .appendTo($picBD),
            $cursor = $(
              '<div class="picZoomer-cursor"><i class="f-is picZoomCursor-ico"></i></div>'
            ).appendTo($picBD),
            cursorSizeHalf = {
              w: $cursor.width() / 2,
              h: $cursor.height() / 2,
            },
            $zoomWP = $(
              '<div class="picZoomer-zoom-wp"><img src="" alt="" class="picZoomer-zoom-pic"></div>'
            ).appendTo($this),
            $zoomPic = $zoomWP.find(".picZoomer-zoom-pic");
          opts.picWidth = $pic.width();
          opts.picHeight = $pic.height();

          var picBDOffset = { x: $picBD.offset().left, y: $picBD.offset().top };

          opts.zoomWidth = opts.zoomWidth || opts.picWidth;
          opts.zoomHeight = opts.zoomHeight || opts.picHeight;
          var zoomWPSizeHalf = {
            w: opts.zoomWidth / 2,
            h: opts.zoomHeight / 2,
          };

          $zoomWP.css({
            width: opts.zoomWidth + "px",
            height: opts.zoomHeight + "px",
          });
          $zoomWP.css(
            opts.zoomerPosition || { top: 0, left: opts.picWidth + 30 + "px" }
          );

          $zoomPic.css({
            width: opts.picWidth * opts.scale + "px",
            height: opts.picHeight * opts.scale + "px",
          });

          $picBD
            .on("mouseenter", function () {
              $cursor.show();
              $zoomWP.show();
              $zoomPic.attr("src", $pic.attr("src"));
            })
            .on("mouseleave", function () {
              $cursor.hide();
              $zoomWP.hide();
            })
            .on("mousemove", function (event) {
              var x = event.pageX - picBDOffset.x,
                y = event.pageY - picBDOffset.y;

              // Ensure the cursor stays within the bounds of the image
              x = Math.max(
                cursorSizeHalf.w,
                Math.min(x, opts.picWidth - cursorSizeHalf.w)
              );
              y = Math.max(
                cursorSizeHalf.h,
                Math.min(y, opts.picHeight - cursorSizeHalf.h)
              );

              $cursor.css({
                left: x - cursorSizeHalf.w + "px",
                top: y - cursorSizeHalf.h + "px",
              });

              // Calculate the zoomed image position
              var zoomX = -(x * opts.scale - zoomWPSizeHalf.w),
                zoomY = -(y * opts.scale - zoomWPSizeHalf.h);

              // Ensure the zoomed image doesn't overflow outside the zoom window
              zoomX = Math.max(
                zoomX,
                -(opts.picWidth * opts.scale - opts.zoomWidth)
              );
              zoomY = Math.max(
                zoomY,
                -(opts.picHeight * opts.scale - opts.zoomHeight)
              );
              zoomX = Math.min(zoomX, 0);
              zoomY = Math.min(zoomY, 0);

              $zoomPic.css({
                left: zoomX + "px",
                top: zoomY + "px",
              });
            });

          return $this;
        };

        $.fn.picZoomer.defaults = {
          // picWidth: 400,
          picHeight: 400,
          scale: 2,
          zoomerPosition: { top: "0", left: "500px" },
          zoomWidth: 300,
          zoomHeight: 400,
        };
      })(jQuery);
    }
    const imageForZoomer =
      selectedContent && !selectedContent.includes("youtube.com")
        ? selectedContent
        : `${ImageURL}${coverImage}`;
    if (!isVideo) {
      // Clean up any existing picZoomer markup
      $(".picZoomer-pic-wp, .picZoomer-cursor, .picZoomer-zoom-wp").remove();
      setTimeout(() => {
        $(".picZoomer").find("img.my_img").attr("src", imageForZoomer);
        $(".picZoomer").picZoomer();
      }, 10); // Adjust timeout if needed for DOM rendering
    }

    // Handle image click in the thumbnail list
    $(".piclist li").on("click", function (event) {
      var $pic = $(this).find("img");
      $(".picZoomer-pic").attr("src", $pic.attr("src"));
    });

    // Cleanup function

    const paymentIcon = $(".payment");
    const cartIcon = $(".cart");
    const navbar = $(".navbar");
    const logo = $(".navbar .logo> img");
    navbar.addClass("shared-banner-style");
    logo.attr("src", "/assets/images/corporate-img/img/logo/meridian.png");
    if (navbar.hasClass("shared-banner-style")) {
      $(".navbar .navbar-nav .nav-link").css("color", "#000");
      $(".dropdown .nav-link i").css("color", "black");
      $(".payment ,.cart")
        .css({
          color: "black",
          display: "block",
          visibility: "visible",
          opacity: 1,
          position: "relative",
          zIndex: 9999,
          top: "10px",
        })
        .addClass("force-black");
    }

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      $(".payment ,.cart")
        .css({
          color: "black",
          display: "block",
          visibility: "visible",
          opacity: 1,
          position: "relative",
          zIndex: 9999,
          top: "10px",
        })
        .addClass("force-black");
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      // Cleanup picZoomer event listeners
      $(".picZoomer").off().find("*").off();
    };
  }, [selectedContent, isVideo, coverImage]);

  const fetchCategories = async () => {
    try {
      const response = await corefetch(
        `Rental/GetPopularCategoryDetailsForFrontend`
      );

      if (response && response.length > 0) {
        const mappedCategories = response.map((category) => ({
          ...category,
          image: category.imagePath ? `${ImageURL}${category.imagePath}` : null,
        }));
        setCategories(mappedCategories);
      } else {
        setCategories([]);
      }
    } catch (error) {
      setCategories([]);
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleGetQuote = () => {
    const storedQuotes = localStorage.getItem("quote_items");
    let quoteItems = storedQuotes ? JSON.parse(storedQuotes) : [];

    // Check if the item already exists in the quoteItems array
    const existingItemIndex = quoteItems.findIndex(
      (item) => item.itemid === items[0]?.itemID
    );

    // If the item doesn't exist, add it to the list
    if (existingItemIndex === -1) {
      const imageToUse = coverImage;

      const itemToAdd = {
        itemid: items[0]?.itemID,
        itemName: items[0]?.itemName,
        imagePath: imageToUse,
        category: items[0]?.category,
        quantity: 1,
      };

      quoteItems.push(itemToAdd);

      localStorage.setItem("quote_items", JSON.stringify(quoteItems));
    }

    // Show the modal
    setShowModal(true);
  };

  const addToCart = () => {
    const storedCart = localStorage.getItem("cart_items");
    let cartItems = storedCart ? JSON.parse(storedCart) : [];

    const existingItem = cartItems.find(
      (item) => item.itemid === items[0]?.itemID
    );

    if (existingItem) {
      // If the item already exists, show toast and return early
      toast.warn("Item Already added in cart!", {
        autoClose: 2000,
        style: { fontWeight: "bold" },
      });
      return; // ✅ Stops execution, preventing quantity update
    }

    // If item does not exist, add as a new item
    const itemToAdd = {
      itemid: items[0]?.itemID,
      itemName: items[0]?.itemName,
      imagePath: coverImage,
      category: items[0]?.category,
      quantity: 1,
    };

    cartItems.push(itemToAdd);

    toast.success("Item added to cart!", {
      autoClose: 2000,
      style: { fontWeight: "bold" },
    });

    localStorage.setItem("cart_items", JSON.stringify(cartItems));
    localStorage.setItem(
      "cart_count",
      cartItems.reduce((acc, item) => acc + item.quantity, 0)
    );

    // Dispatch a custom event to notify other components
    window.dispatchEvent(new Event("cartUpdated"));
  };

  const handleToggleChange = () => {
    setIsToggleOn((prev) => !prev);
  };

  const handleDateChange = (e) => {
    const selectedDate = e ? e : null;
    if (selectedDate == null || selectedDate == "") {
      setVendor((prev) => ({
        ...prev,
        EventDate: null,
      }));
      setError((prevErr) => ({
        ...prevErr,
        EventDate: true,
      }));
    } else {
      setVendor((prev) => ({
        ...prev,
        EventDate: selectedDate,
      }));
      setError((prevErr) => ({
        ...prevErr,
        EventDate: false,
      }));
    }
  };
  const handleOutsideDateChange = (e) => {
    const selectedDate = e ? e : null;
    if (selectedDate == null) {
      setVendor((prev) => ({
        ...prev,
        OutsideEventDate: null,
      }));
      setError({ ...error, OutsideEventDate: true });
    } else {
      setVendor((prev) => ({
        ...prev,
        OutsideEventDate: selectedDate,
      }));
      setError({ ...error, OutsideEventDate: false });
    }
  };

  const onValidation = (field, value) => {
    if (value === "") {
      setError((prev) => ({ ...prev, [field]: true }));
    } else {
      setError((prev) => ({ ...prev, [field]: false }));
    }
  };
  const clearForm = () => {
    setVendor({
      ClientName: "",
      EventDate: "",
      BallroomID: 0,
      ClientPhoneNumber: "",
      ClientEmailID: "",
      Name: "",
      Email: "",
      PhoneNumber: "",
      VenueLocation: "",
      OutsideEventDate: "",
    });
    setError({});
    setIsToggleOn(false);

    const form = document.getElementById("form-culture-config");
    if (form) {
      form.reset();
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    let err = ValidateForm(e) || {};
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    let rawPhoneValue = vendor.ClientPhoneNumber.replace(/\D/g, "");
    let rawPhoneValues = vendor.PhoneNumber.replace(/\D/g, "");

    if (isToggleOn) {
      if (!vendor.ClientPhoneNumber) {
        err.ClientPhoneNumber = "Phone number is required";
      } else if (rawPhoneValue.length !== 10) {
        err.ClientPhoneNumber = "Phone number must be 10 digits";
      }
      if (!vendor.BallroomID || vendor.BallroomID === "0") {
        err.BallroomID = true;
      }
      if (!vendor.ClientEmailID) {
        err.ClientEmailID = "Email ID is required";
      } else if (!emailPattern.test(vendor.ClientEmailID)) {
        err.ValidEmail = "Invalid email address";
      }
    } else {
      if (!vendor.Email) {
        err.Email = "Email ID is required";
      } else if (!emailPattern.test(vendor.Email)) {
        err.ValidEmail = "Invalid email address";
      }
      if (!vendor.PhoneNumber) {
        err.PhoneNumber = "Phone number is required";
      } else if (rawPhoneValues.length !== 10) {
        err.PhoneNumber = "Phone number must be 10 digits";
      }
    }

    if (Object.keys(err).length > 0) {
      setError(err);
    } else {
      const formData = new FormData();
      const cartItems = JSON.parse(localStorage.getItem("quote_items")) || [];

      cartItems.forEach((item, index) => {
        formData.append(`QuoteDetails[${index}].ItemID`, item.itemid);
        formData.append(`QuoteDetails[${index}].ItemName`, item.itemName);
        formData.append(`QuoteDetails[${index}].Category`, item.category);
        formData.append(`QuoteDetails[${index}].Quantity`, item.quantity);
        formData.append(`QuoteDetails[${index}].ImagePath`, item.imagePath);
      });

      formData.append("ClientName", vendor.ClientName);
      formData.append(
        "EventDate",
        vendor.EventDate
          ? new Date(vendor.EventDate).toLocaleString()
          : new Date().toLocaleString()
      );
      formData.append(
        "OutsideEventDate",
        vendor.OutsideEventDate
          ? new Date(vendor.OutsideEventDate).toLocaleString()
          : new Date().toLocaleString()
      );
      formData.append("BallroomID", vendor.BallroomID);
      formData.append("ClientPhonenumber", vendor.ClientPhoneNumber);
      formData.append("Name", vendor.Name);
      formData.append("ClientEmailID", vendor.ClientEmailID);
      formData.append("EmailId", vendor.Email);
      formData.append("PhoneNumber", vendor.PhoneNumber);
      formData.append("VenueLocation", vendor.VenueLocation);
      formData.append("IsMeridianClient", isToggleOn ? "1" : "0");

      try {
        await corepost(
          "Rental/InsertUpdateCustomerDetails",
          formData,
          false,
          false,
          false,
          false,
          "Submitted Successfully"
        );

        // Set the Calendly URL based on whether the client is Meridian or not
        if (calendlyLinks) {
          const calendlyUrl = isToggleOn
            ? calendlyLinks.meridianCalendlyLink
            : calendlyLinks.noN_MeridianCalendlyLink;
          setSelectedCalendlyUrl(calendlyUrl);
          setShowCalendlyModal(true); // Show the modal
        }

        localStorage.removeItem("quote_items");
        clearForm();
        closeModal();
      } catch (error) {
        console.error("Error saving vendor data:", error);
      }
    }
  };

  const closeModal = () => {
    setShowModal(false);
    clearForm();
  };
  const fetchBallroomData = async () => {
    try {
      const list = await corefetch("Facility/GetActiveBallroomData");
      if (list && list.length > 0) {
        setBallroomData(list);
      }
    } catch (error) {
      console.error("Error fetching list:", error);
    }
  };
  useEffect(() => {
    fetchBallroomData();
  }, []);
  const openModal = () => {
    fetchBallroomData();
    setShowModal(true);
  };
  const closeThankYouModal = () => {
    setShowThankYouModal(false);
  };
  const handleBack = () => {
    navigate(-1); // Navigate to the previous page
  };

  useEffect(() => {
    if (showModal) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [showModal]);

  const scrollContainerRef = useRef(null);

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      if (scrollContainerRef.current.scrollLeft > 0) {
        scrollContainerRef.current.scrollBy({ left: -200, behavior: "smooth" });
      }
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };
  useEffect(() => {
    const handlePopState = () => {
      window.location.reload();
    };

    window.addEventListener("popstate", handlePopState);
    window.onpageshow = function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    };

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  useEffect(() => {
    const fetchCalendlyLinks = async () => {
      try {
        const response = await corefetch(`Decoration/GetCalendlyLinks`);

        if (response && response.length > 0) {
          setCalendlyLinks(response[0]); // Assuming only one set of links
        }
      } catch (error) {
        console.error("Error fetching Calendly links:", error);
      }
    };

    fetchCalendlyLinks();
  }, []);
  useEffect(() => {
    if (showCalendlyModal) {
      document.body.style.overflow = "hidden"; // Disable scrolling
    } else {
      document.body.style.overflow = ""; // Restore scrolling
    }

    return () => {
      document.body.style.overflow = ""; // Ensure scrolling is restored when unmounting
    };
  }, [showCalendlyModal]);

  return (
    <>
      <div className="wpo-page-title " style={backgroundImageStyle}>
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <div
                className="wpo-breadcumb-wrap"
                style={{ textAlign: "center" }}
              >
                <h2 style={{ color: "white" }}>{items[0]?.itemName}</h2>{" "}
                <ol
                  className="wpo-breadcumb-wrap"
                  style={{
                    color: "white",
                    display: "inline-block",
                    padding: 0,
                  }}
                >
                  <li>
                    <span
                      onClick={handleBack}
                      style={{
                        cursor: "pointer",
                        color: "white",
                      }}
                    >
                      Items
                    </span>
                  </li>
                  <span style={{ color: "white", margin: "0 5px" }}>|</span>
                  <li
                    style={{
                      color: "white",
                    }}
                  >
                    {items[0]?.itemName}
                  </li>
                </ol>
              </div>
            </div>
          </div>{" "}
        </div>{" "}
      </div>
      <section
        className="rooms4 section-padding RentalcartBackground"
        style={{ marginLeft: "34px" }}
        data-scroll-index={1}
      >
        <div className="container bottom-border RentalContainer">
          <div className="row">
            <div className="col-lg-6 col-md-8 col-sm-12">
              <div className="row row-sm">
                <div className="_boxzoom">
                  <div className="_product-images">
                    {isVideo ? (
                      <div className="video-wrapper" key={selectedContent}>
                        <ReactPlayer
                          url={selectedContent}
                          controls={true}
                          playing={true}
                          width="100%"
                          height="400px"
                          title="Selected Video"
                        />
                      </div>
                    ) : (
                      <div
                        className="picZoomer"
                        key={selectedContent || coverImage}
                      >
                        <img
                          className="my_img"
                          src={selectedContent || `${ImageURL}${coverImage}`}
                          alt="Main Image"
                        />
                      </div>
                    )}
                  </div>

                  {/* Ensure wrapper for scrolling works */}
                  <div className="thumb-container">
                    <button
                      className="scroll-btn leftIcon"
                      onClick={scrollLeft}
                    >
                      <i className="las la-chevron-left"></i>
                    </button>
                    <div className="zoom-thumb" ref={scrollContainerRef}>
                      <ul className="piclist">
                        {items.flatMap((item) => {
                          const imageItems =
                            item.imageModels?.map((img) => (
                              <li
                                key={`img-${item.id}-${img.imageID}`}
                                onClick={() =>
                                  handleImageClick(
                                    `${ImageURL}${img.imagePath}`
                                  )
                                }
                              >
                                <img
                                  src={`${ImageURL}${img.imagePath}`}
                                  alt={item.itemName}
                                />
                              </li>
                            )) || [];

                          const videoItem = item.youtubeLink ? (
                            <li
                              key={`video-${item.id}`}
                              onClick={() => handleVideoClick(item.youtubeLink)}
                            >
                              <img
                                src="../assets/images/Buttons/youtube-icon-square.png"
                                alt="Video Thumbnail"
                              />
                            </li>
                          ) : null;

                          return [...imageItems, videoItem].filter(Boolean);
                        })}
                      </ul>
                    </div>
                    {/* Right Scroll Button */}
                    <button
                      className="scroll-btn rightIcon"
                      onClick={scrollRight}
                    >
                      <i className="las la-chevron-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-4 col-sm-3 scrollable-div">
              <div className="d-flex justify-content-between align-items-start">
                {/* Ensure item name wraps if too long */}
                <h3
                  className="product_header"
                  style={{
                    maxWidth: "70%", // Limits width to avoid pushing the button
                    whiteSpace: "normal", // Allows text to wrap to next line
                    wordBreak: "break-word", // Ensures long words don't overflow
                  }}
                >
                  {items[0]?.itemName}
                </h3>

                {/* Prevent button from shrinking & align to top */}
                <div className="purches-btn flex-shrink-0">
                  {items[0]?.category === "Rental" ? (
                    <span>
                      <a className="CartButtons addCursor" onClick={addToCart}>
                        <span>Add to Cart</span>
                      </a>
                    </span>
                  ) : items[0]?.category === "Decoration" ? (
                    <span>
                      <a
                        onClick={handleGetQuote}
                        className="CartButtons addCursor"
                      >
                        <span>Get Quote</span>
                      </a>
                    </span>
                  ) : null}
                </div>
              </div>
              {/* <div className="_p-add-cart ">
                <div className="_p-qty offers-header">
                  <div
                    className="value-button decrease_"
                    id
                    value="Decrease Value"
                    onClick={() => updateQuantity(index, -1)}
                  >
                    -
                  </div>
                  <input
                    name="qty"
                    id="number"
                    type="number"
                    value={items.quantity}
                    readOnly
                  />
                  <div
                    className="value-button increase_"
                    id
                    value="Increase Value"
                    onClick={() => updateQuantity(index, 1)}
                  >
                    +
                  </div>
                </div>
              </div> */}
              <div>
                <span>
                  <h5 className="offers-header">About this item</h5>
                </span>
                <p>{items[0]?.description}</p>
              </div>
            </div>
          </div>
          <br />
          {categories.length > 0 && (
            <div className="container bottom-border RentalContainer">
              <h4 className="product_header">Recommended Categories</h4>
              <div className="container">
                {/* Owl Carousel for Recommended Categories */}
                <div className="services-carousel owl-theme owl-carousel">
                  {categories.map((category) => (
                    <div key={category.itemID} className="item">
                      <div className="rooms1-single">
                        <div className="rooms1-img">
                          <img
                            style={{ objectFit: "cover" }}
                            src={`${ImageURL}${category.imagePath}`}
                            className="ImageControll"
                            alt={category.categoryName}
                          />
                        </div>
                        <div className="rooms1-content active">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="r-rooms1-title ftsz d-flex justify-content-between align-items-center">
                                <a>{category.categoryName}</a>
                                <a
                                  className="text-end"
                                  href={`/rentalitem/${category.categoryID}`}
                                >
                                  <span className="ti-arrow-right" />
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
      {showModal && (
        <div className="popup">
          <div className="modal-content venues">
            <span className="close" onClick={closeModal}>
              &times;
            </span>
            {/* <h3>Are you a Meridian Client?</h3> */}
            <form
              id="form-culture-config"
              className="styled-form"
              onSubmit={handleSubmit}
            >
              <div className="form-section custom row align-items-center">
                <div className="col-md-7 col-12 text-md-end text-center mb-2 mb-md-0">
                  <label className="toggle">
                    Is Your Event is at Meridian?
                  </label>
                </div>
                <div className="col-md-5 col-12 d-flex justify-content-center justify-content-md-start">
                  <div className="toggle-switch">
                    <input
                      type="checkbox"
                      id="meridian-toggle"
                      name="meridianEvent"
                      onChange={handleToggleChange}
                      checked={isToggleOn}
                    />
                    <label htmlFor="meridian-toggle" className="toggle-label" />
                  </div>
                </div>
              </div>

              {isToggleOn ? (
                // Meridian Clients Form
                <div key="meridian-form" className="form-section margin">
                  <div className="row">
                    <div className="col-md-4 col-12 mb-3">
                      <label
                        htmlFor="clientName"
                        className="text-start d-block"
                        style={{ textAlign: "left" }}
                      >
                        Client Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="control form-control"
                        placeholder="Enter Client Name"
                        name="ClientName"
                        value={vendor.ClientName}
                        data-required="true"
                        onChange={(e) => {
                          setVendor({ ...vendor, ClientName: e.target.value });
                          onValidation("ClientName", e.target.value);
                        }}
                      />
                      <CommonErrorMsg
                        text="Client Name is required"
                        IsError={error.ClientName}
                      />
                    </div>
                    <div className="col-md-4 col-12 mb-3">
                      <label
                        htmlFor="email"
                        className="text-start d-block"
                        style={{ textAlign: "left" }}
                      >
                        Email ID <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className="control form-control"
                        placeholder="Enter Email ID"
                        name="ClientEmailID"
                        value={vendor.ClientEmailID}
                        data-required="true"
                        onChange={(e) => {
                          setVendor((prev) => ({
                            ...prev,
                            ClientEmailID: e.target.value,
                          }));
                          onValidation("ClientEmailID", e.target.value);
                          // Email validation
                          const emailPattern =
                            /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

                          // Check if the email is valid or not
                          if (
                            !emailPattern.test(e.target.value) &&
                            e.target.value !== ""
                          ) {
                            setError((prevError) => ({
                              ...prevError,
                              ValidEmail: true,
                            }));
                          } else {
                            setError((prevError) => ({
                              ...prevError,
                              ValidEmail: false,
                            }));
                          }
                        }}
                      />
                      {error.ValidEmail && (
                        <ErrorMsg text="Please provide a valid email address" />
                      )}
                      <CommonErrorMsg
                        text="Email ID is required"
                        IsError={error.ClientEmailID}
                      />
                    </div>
                    <div className="col-md-4 col-12 mb-3">
                      <label
                        htmlFor="eventDate"
                        className="text-start d-block"
                        style={{ textAlign: "left" }}
                      >
                        Event Date
                      </label>
                      <KendoDatePicker
                        name="EventDate"
                        value={vendor.EventDate}
                        format="MM/dd/yyyy"
                        onChange={handleDateChange}
                        disablePast={true}
                      />
                    </div>
                    <div className="col-md-4 col-12 mb-3">
                      <label
                        htmlFor="vendorType"
                        className="text-start d-block"
                        style={{ textAlign: "left" }}
                      >
                        Ballroom <span className="text-danger">*</span>
                      </label>
                      <select
                        id="vendorType"
                        className="control form-control"
                        name="BallroomID"
                        value={vendor.BallroomID}
                        onChange={(e) => {
                          const value = parseInt(e.target.value, 10);
                          if (vendor) {
                            setVendor((prev) => ({
                              ...prev,
                              BallroomID: value,
                            }));
                            onValidation("BallroomID", value);
                          }
                        }}
                      >
                        <option value={0} disabled>
                          Select Ballroom
                        </option>
                        {ballroomData.map((ballroom) => (
                          <option
                            key={ballroom.facilityID}
                            value={ballroom.facilityID}
                          >
                            {ballroom.facilityName}
                          </option>
                        ))}
                      </select>
                      <CommonErrorMsg
                        text="Ballroom is required"
                        IsError={error.BallroomID}
                      />
                    </div>
                    <div className="col-md-4 col-12 mb-3">
                      <label
                        htmlFor="phoneNo"
                        className="text-start d-block"
                        style={{ textAlign: "left" }}
                      >
                        Phone No <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="control form-control"
                        placeholder="Enter PhoneNumber"
                        name="ClientPhoneNumber"
                        value={vendor.ClientPhoneNumber || ""}
                        data-required="true"
                        onChange={(e) => {
                          // Clear previous error message
                          setError((prevError) => ({
                            ...prevError,
                            ClientPhoneNumber: false, // Clear the 'PhoneNumber' required error
                            invalidNo: false, // Clear the 'invalidNo' error state
                          }));

                          let rawValue = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters

                          // Limit the number of digits to 10
                          if (rawValue.length > 10)
                            rawValue = rawValue.substring(0, 10);

                          // Format the phone number as (XXX) XXX-XXXX
                          let formattedValue = "";
                          if (rawValue.length > 3) {
                            formattedValue = `(${rawValue.substring(
                              0,
                              3
                            )}) ${rawValue.substring(3, 6)}${
                              rawValue.length > 6
                                ? "-" + rawValue.substring(6)
                                : ""
                            }`;
                          } else if (rawValue.length > 0) {
                            formattedValue = `(${rawValue}`;
                          }

                          // Update the phone number in the vendor state
                          setVendor((prev) => ({
                            ...prev,
                            ClientPhoneNumber: formattedValue,
                          }));

                          if (rawValue.length === 0) {
                            setError((prevError) => ({
                              ...prevError,
                              ClientPhoneNumber: true, // Set error for empty phone number
                              invalidNo: false, // Clear the invalid number error
                            }));
                          } else if (rawValue.length < 10) {
                            setError((prevError) => ({
                              ...prevError,
                              invalidNo: true, // Set error for invalid number
                              ClientPhoneNumber: false, // Clear the required error
                            }));
                          } else {
                            // Clear all errors if the phone number is valid
                            setError((prevError) => ({
                              ...prevError,
                              ClientPhoneNumber: false,
                              invalidNo: false,
                            }));
                          }

                          onValidation("ClientPhoneNumber", formattedValue);
                        }}
                      />
                      {error.invalidNo && (
                        <CommonErrorMsg
                          text="Phone number must be 10 digits"
                          IsError={true}
                        />
                      )}
                      <CommonErrorMsg
                        text="Phone Number is required"
                        IsError={error.ClientPhoneNumber}
                      />
                    </div>

                    {calendlyLinks?.description && (
                      <div
                        className="mt-2 text-start"
                        style={{ textAlign: "left" }}
                      >
                        <strong style={{ fontWeight: "700" }}>Note: </strong>{" "}
                        {calendlyLinks.description}
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                // Non-Meridian Clients Form
                <div key="non-meridian-form" className="form-section margin">
                  <div className="row">
                    <div className="col-md-4 col-12 mb-3">
                      <label
                        htmlFor="name"
                        className="text-start d-block"
                        style={{ textAlign: "left" }}
                      >
                        Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="control form-control"
                        placeholder="Enter Your Name"
                        name="Name"
                        value={vendor.Name}
                        data-required="true"
                        onChange={(e) => {
                          setVendor({ ...vendor, Name: e.target.value });
                          onValidation("Name", e.target.value);
                        }}
                      />
                      <CommonErrorMsg
                        text="Name is required"
                        IsError={error.Name}
                      />
                    </div>
                    <div className="col-md-4 col-12 mb-3">
                      <label
                        htmlFor="email"
                        className="text-start d-block"
                        style={{ textAlign: "left" }}
                      >
                        Email ID <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className="control form-control"
                        placeholder="Enter Email ID"
                        name="Email"
                        value={vendor.Email}
                        data-required="true"
                        onChange={(e) => {
                          setVendor((prev) => ({
                            ...prev,
                            Email: e.target.value,
                          }));
                          onValidation("Email", e.target.value);
                          // Email validation
                          const emailPattern =
                            /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

                          // Check if the email is valid or not
                          if (
                            !emailPattern.test(e.target.value) &&
                            e.target.value !== ""
                          ) {
                            setError((prevError) => ({
                              ...prevError,
                              ValidEmail: true,
                            }));
                          } else {
                            setError((prevError) => ({
                              ...prevError,
                              ValidEmail: false,
                            }));
                          }
                        }}
                      />
                      {error.ValidEmail && (
                        <ErrorMsg text="Please provide a valid email address" />
                      )}
                      <CommonErrorMsg
                        text="Email ID is required"
                        IsError={error.Email}
                      />
                    </div>
                    <div className="col-md-4 col-12 mb-3">
                      <label
                        htmlFor="eventDate"
                        className="text-start d-block"
                        style={{ textAlign: "left" }}
                      >
                        Event Date
                      </label>
                      <KendoDatePicker
                        name="OutsideEventDate"
                        value={vendor.OutsideEventDate}
                        format="MM/dd/yyyy"
                        onChange={handleOutsideDateChange}
                        disablePast={true}
                      />
                    </div>
                    <div className="col-md-4 col-12 mb-3">
                      <label
                        htmlFor="phone"
                        className="text-start d-block"
                        style={{ textAlign: "left" }}
                      >
                        Phone Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="control form-control"
                        placeholder="Enter Phone Number"
                        name="PhoneNumber"
                        value={vendor.PhoneNumber}
                        data-required="true"
                        onChange={(e) => {
                          // Clear previous error message
                          setError((prevError) => ({
                            ...prevError,
                            PhoneNumber: false, // Clear the 'PhoneNumber' required error
                            invalidNo: false, // Clear the 'invalidNo' error state
                          }));

                          let rawValue = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters

                          // Limit the number of digits to 10
                          if (rawValue.length > 10)
                            rawValue = rawValue.substring(0, 10);

                          // Format the phone number as (XXX) XXX-XXXX
                          let formattedValue = "";
                          if (rawValue.length > 3) {
                            formattedValue = `(${rawValue.substring(
                              0,
                              3
                            )}) ${rawValue.substring(3, 6)}${
                              rawValue.length > 6
                                ? "-" + rawValue.substring(6)
                                : ""
                            }`;
                          } else if (rawValue.length > 0) {
                            formattedValue = `(${rawValue}`;
                          }

                          // Update the phone number in the vendor state
                          setVendor((prev) => ({
                            ...prev,
                            PhoneNumber: formattedValue,
                          }));

                          if (rawValue.length === 0) {
                            setError((prevError) => ({
                              ...prevError,
                              PhoneNumber: true, // Set error for empty phone number
                              invalidNo: false, // Clear the invalid number error
                            }));
                          } else if (rawValue.length < 10) {
                            setError((prevError) => ({
                              ...prevError,
                              invalidNo: true, // Set error for invalid number
                              PhoneNumber: false, // Clear the required error
                            }));
                          } else {
                            // Clear all errors if the phone number is valid
                            setError((prevError) => ({
                              ...prevError,
                              PhoneNumber: false,
                              invalidNo: false,
                            }));
                          }

                          onValidation("PhoneNumber", formattedValue);
                        }}
                      />
                      {error.invalidNo && (
                        <CommonErrorMsg
                          text="Phone number must be 10 digits"
                          IsError={true}
                        />
                      )}
                      <CommonErrorMsg
                        text="Phone Number is required"
                        IsError={error.PhoneNumber}
                      />
                    </div>
                    <div className="col-md-4 col-12 mb-3">
                      <label
                        htmlFor="venueLocation"
                        className="text-start d-block"
                        style={{ textAlign: "left" }}
                      >
                        Venue Location <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="control form-control"
                        placeholder="Enter Venue Location"
                        name="VenueLocation"
                        value={vendor.VenueLocation}
                        data-required="true"
                        onChange={(e) => {
                          setVendor({
                            ...vendor,
                            VenueLocation: e.target.value,
                          });
                          onValidation("VenueLocation", e.target.value);
                        }}
                      />
                      <CommonErrorMsg
                        text="Venue Location is required"
                        IsError={error.VenueLocation}
                      />
                    </div>
                    {calendlyLinks?.description && (
                      <div
                        className="mt-2 text-start"
                        style={{ textAlign: "left" }}
                      >
                        <strong style={{ fontWeight: "700" }}>Note: </strong>{" "}
                        {calendlyLinks.description}
                      </div>
                    )}
                  </div>
                </div>
              )}

              <button type="submit" className="CartButtons">
                Submit
              </button>
            </form>
          </div>
        </div>
      )}
      {showCalendlyModal && selectedCalendlyUrl && (
        <div className="calendly-overlay">
          <div className="calendly-popup">
            <div className="calendly-modal-content">
              <button
                className="close-button"
                onClick={() => setShowCalendlyModal(false)}
              >
                ✖
              </button>
              <iframe
                target="_self"
                src={selectedCalendlyUrl}
                title="Calendly"
                style={{ width: "100%", height: "100%" }}
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </>
  );
  // function updateQuantity(index, change) {
  //   let updatedCart = [...cartItems];
  //   updatedCart[index].quantity += change;
  //   if (updatedCart[index].quantity < 1) updatedCart[index].quantity = 1;
  //   setCartItems(updatedCart);
  //   localStorage.setItem("cart_items", JSON.stringify(updatedCart));
  // }
};

export default Cart;
